// Module
var code = `<customer-breadcrumbs mode="'GROUP'"></customer-breadcrumbs>
<customer-profile-header mode="'GROUP'"></customer-profile-header>
<div class="group-loans-create box">
  <sub-header header="\$ctrl.getBatchApplicationHeader()"></sub-header>

    <div ng-if="\$ctrl.fsm.state == 'membersSelection'">
      <group-loans-create-members
              group-profile="\$ctrl.groupProfile"
              members="\$ctrl.members"
              prepare-loan-action="\$ctrl.prepareLoan"
              save-application-action="\$ctrl.saveApplication"
              edit-group-loan-action="\$ctrl.editGroupLoan"
              edit-loan-action="\$ctrl.editLoan"
      >
      </group-loans-create-members>
    </div>
    <div ng-if="\$ctrl.fsm.state == 'productSelection'">
      <customer-loan-create-list-table
              loan-type="\$ctrl.loanType"
              open-action="\$ctrl.openAction"
              customer-type="'GROUP'"
              customer-ids="\$ctrl.applyingMemberIds"
      >
      </customer-loan-create-list-table>
    </div>
    <div ng-if="\$ctrl.fsm.state == 'membersProductConfiguration'">
      <group-loans-create-form
              default-member="\$ctrl.defaultMember"
              members="\$ctrl.applyingMembers"
              product="\$ctrl.product"
              group-profile="\$ctrl.groupProfile"
              form-submit-action="\$ctrl.memberConfigurationFinishedAction"
              form-cancel-action="\$ctrl.returnToMemberSelection"
      >
      </group-loans-create-form>
    </div>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/group-loans/group-loans-create/group-loans-create.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;